/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ error: NonNullable<unknown> }} Voice_Manager_Render_Failed_ToastInputs */



/**
* | output |
* | --- |
* | "Audio Rendering Failed. {error}" |
*
* @param {Voice_Manager_Render_Failed_ToastInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const voice_manager_render_failed_toast = /** @type {((inputs: Voice_Manager_Render_Failed_ToastInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Voice_Manager_Render_Failed_ToastInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ (`Echec du rendu audio. ${i?.error}`)
	if (locale === "de") return /** @type {LocalizedString} */ (`Audiowiedergabe fehlgeschlagen. ${i?.error}`)
	if (locale === "it") return /** @type {LocalizedString} */ (`Rendering audio non riuscito. ${i?.error}`)
	if (locale === "ru") return /** @type {LocalizedString} */ (`Ошибка при рендеринге звука. ${i?.error}`)
	if (locale === "es") return /** @type {LocalizedString} */ (`Error en la representación de audio. ${i?.error}`)
	if (locale === "zh-CN") return /** @type {LocalizedString} */ (`音频渲染失败。${i?.error}`)
	if (locale === "ja") return /** @type {LocalizedString} */ (`オーディオのレンダリングに失敗しました。${i?.error}`)
	if (locale === "hi") return /** @type {LocalizedString} */ (`ऑडियो रेंडरिंग विफल रही। ${i?.error}`)
	if (locale === "pt-PT") return /** @type {LocalizedString} */ (`Falha na renderização de áudio. ${i?.error}`)
	return /** @type {LocalizedString} */ (`Audio Rendering Failed. ${i?.error}`)
});